import { useMemo } from 'react';
import { TInheritedProps } from '@ts/storybook';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IConfigComponent, CChannel, CDistributionList } from '@ts/ui-models';
import { generateGlobalColumns, generateEntityColumn, IDataGridConfig } from '@ts/storybook';

interface IDistributionListProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'distributionList',
  aclId: 'DistList',
  entity: 'distributionList',
  fetchURL: '/api/distributionLists',
  crudURL: '/api/distributionList',
  mainClass: CDistributionList,
};

const DistributionLists = (props: IDistributionListProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [
      globalCells.id(),
      globalCells.name(),
      generateEntityColumn(
        { field: 'channel', headerName: 'Channel Name' },
        { tEntity: 'channel', mainClass: CChannel },
        { inheritedProps }
      ),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default DistributionLists;
